import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-bodytext',
  templateUrl: './bodytext.component.html'
})
export class BodytextComponent implements OnInit {

  @Input() data;

  constructor() { }

  ngOnInit() {
  }

}
